var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 149,
    viewBox: "0 0 306 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.497 101.72L255.763 96.1826C234.355 92.3253 215.716 79.2731 204.772 60.4748L196.771 46.7324C190.462 35.8958 179.562 28.5214 167.156 26.696V26.696C151.214 24.3505 135.368 31.5112 126.593 45.0256L111.66 68.0247C96.6217 91.1866 71.153 105.47 43.5475 106.224L6.5605 107.235",
    stroke: "#212121",
    strokeOpacity: 0.25,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.888 102.061L262.84 98.4055C239.307 94.6735 217.953 82.8016 202.5 64.8597L192.453 53.1948C180.309 39.0951 162.703 30.829 143.947 30.4204L137.641 30.283C112.73 29.7403 90.0282 45.1391 81.2499 68.5336V68.5336C72.6462 91.4627 50.6381 106.763 26.2087 106.798L4.90049 106.829",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M294.876 111.588L271.646 108.671C247.961 105.696 225.916 95.369 208.617 79.1442L192.394 63.9286C183.668 55.7435 172.31 50.8885 160.276 50.1986V50.1986C145.77 49.3671 131.493 54.6505 120.922 64.762L106.637 78.4255C87.5618 96.671 61.975 106.494 35.763 105.635L14.9718 104.954",
    stroke: "#212121",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLineChart);
export default __webpack_public_path__ + "static/media/no-data-line-chart.26f72690569e1e8990a42a6875837073.svg";
export { ForwardRef as ReactComponent };